console.log("Shopify.theme.schema_name",Shopify.theme.schema_name)
if(Shopify.theme.schema_name != "Dawn"){
var pathSh = meta.page.pageType;
var photo_and_print_collection = ['284466806947', '237871333539', '231683031203', '293111759011', '218500530339', '212778352803', '288808173731','215330324643']
if (pathSh == 'collection'){
	var collectionPageId = meta.page.resourceId
	if(photo_and_print_collection.includes(String(collectionPageId))){
		if (window.matchMedia("(min-width: 320px) and (max-width: 750px)").matches) {
			document.querySelectorAll('.image-wrap').forEach(element => {
				element.style.boxShadow = '3px 5px 10px #0000009e';
			});
			document.querySelectorAll('.grid-product__image').forEach(element => {
				element.style.border = '5px solid #494949';
				element.style.padding = '15px';
				element.style.backgroundColor = '#fff';
				element.style.boxShadow = '0px 0px 3px #000 inset';
			});
		}else{
			document.querySelectorAll('.image-wrap').forEach(element => {
				element.style.boxShadow = '3px 5px 10px #0000009e';
			});
			document.querySelectorAll('.grid-product__image').forEach(element => {
				element.style.border = '10px solid #494949';
				element.style.padding = '20px';
				element.style.backgroundColor = '#fff';
				element.style.boxShadow = '0px 0px 5px #000 inset';
			});
		}
	}
}

if (pathSh == 'product') {
	console.log("inside product page arun and deva");
	if (performance && performance.getEntriesByType("navigation")[0]?.type === "back_forward") {
		console.log("Navigated back to product page – reloading...");
		location.reload();
	}
	if (document.getElementsByTagName('larfsh-variant-selects')[0]) {
		loadjscssfile("https://shop.liveb4buy.com/lb4b-shop/dist/css/livevue-template.min.css", "css");
		var dataObject = [];
		var livevueImgUpload = false;
		let sideWrapSh = document.querySelector('#sideShow')
		var orderImage;
		var selectedOptions
		var selectedFrame
		var printOnlySelect = false
		var finalPrice = 0;
		var updatedPriceFinal;
		var result;
		var orderImage;
		var woodMountColor;
		var woodMountColorName;
		var sizeElement_PS;
		var hispicThreeD = false;
		const shopUniqueId = Shopify.shop.replace(".myshopify.com", "_myshopify");
		let message = document.createElement("p");
		message.textContent = "Selected variant is unavailable";
		message.style.color = "red";
		message.style.marginBottom = "1rem";
		message.style.display = "none";
		let cart_button = document.querySelector('[name=add]');
		cart_button.parentNode.insertBefore(message, cart_button);
		var priceElement = document.createElement('span');
		priceElement.className = "livevue-display-price";
		priceElement.innerHTML = document.querySelector('#larf-display-price').innerText;
		var placeElement = document.querySelector('#larf-display-price');
		placeElement.insertAdjacentElement('afterend', priceElement);
		placeElement.style.display = 'none';
		var cartPageLoader = document.createElement('div');
		cartPageLoader.id = 'larfloader';
		cartPageLoader.innerHTML = '<div class="loader-spinner"><p></p></div><div class="loader-text">Order Processing...</div>';
		document.querySelector('body').append(cartPageLoader);
		var getToken;
		getToken = getShopToken("livearf_token");
		if (document.getElementsByClassName('uploadYourImage')[0]) {
			livevueImgUpload = true;
			var orgImageUrl;
			var croppedImgUrl;
		}
		var sizeFS = document.querySelector('input[name="Size-1"]').parentElement;
		var typeFS = document.querySelector('input[option_name="Type"]').parentElement;
		var frameFS = document.querySelector('input[action="frame"]').parentElement;
		var matSizeFS = document.querySelector('input[action="1st-mat-size"]').parentElement;
		var matColorFS = document.querySelector('input[action="1st-mat-style"]').parentElement;
		var matColorElement = document.querySelector('input[action="1st-mat-style"]');
		typeFS.classList.add('js-disable-scope');
		sizeFS.classList.add('js-disable-scope');
		//Elements created for enlarge view
		var offsetwidth = document.getElementsByClassName('mainFrameDiv')[0].offsetWidth;
		var enlarge = document.createElement('div')
		enlarge.id = 'enlarge'
		document.body.appendChild(enlarge);
		var enlargeIcon = document.createElement('img');
		enlargeIcon.id = 'enlargeIcon';
		enlargeIcon.src = 'https://cdn.shopify.com/s/files/1/0773/6655/9038/files/enlarge1.webp';
		enlargeIcon.style.cssText = `padding: 10px;border-radius: 10px;background-color: rgba(0, 0, 0, 0.49); color: rgb(255, 255, 255);top: 0.5rem;text-align: center; z-index: 1; width: 2rem; position: absolute;left: 94%;height:2rem;`;
		var roomImage = document.getElementById('roomImage');
		roomImage.insertAdjacentElement('afterend', enlargeIcon);
		var roomSliderPrev = document.createElement('button');
		roomSliderPrev.className = 'larfhispic_slider-button larfhispic_slider-button-prev';
		roomSliderPrev.innerText = '←';
		roomImage.after(roomSliderPrev);
		var roomSliderNext = document.createElement('button');
		roomSliderNext.className = 'larfhispic_slider-button larfhispic_slider-button-next';
		roomSliderNext.innerText = '→';
		roomImage.after(roomSliderNext);
		var icons = document.querySelectorAll('#room-icons-set li');
		let currentIndex = 0;
		currentSize.lineSize = 40;
		// Helper: trigger click on current index
		function triggerClick(index) {
			if (icons[index]) {
				icons[index].click(); // simulate click
			}
			currentSize.lineSize = 40;
			console.log('lineSize set to:', currentSize.lineSize);
		}
		document.querySelector('.larfhispic_slider-button-next').addEventListener('click', function () {
			currentIndex = (currentIndex + 1) % icons.length; // wrap around
			triggerClick(currentIndex);
		});
		document.querySelector('.larfhispic_slider-button-prev').addEventListener('click', function () {
			currentIndex = (currentIndex - 1 + icons.length) % icons.length; // wrap around
			triggerClick(currentIndex);
		});
		// Optional: Update index if user clicks manually
		icons.forEach((li, index) => {
			li.addEventListener('click', () => {
				currentIndex = index;
				setTimeout(() => {
					currentSize.lineSize = 40;
					console.log('lineSize set to:', currentSize.lineSize);
				}, 1000)
			});
		});
		function getOrderPropertiesSh() {
			const jsonObjectSh = {};
			const selectedValues = document.querySelectorAll(
				'fieldset.rule_visible input[type="radio"]:checked, fieldset:not(.hideBlock) input[type="radio"]:checked'
			);
			selectedValues.forEach(each => {
				jsonObjectSh[each.getAttribute("option_name")] = each.value;
			});
			return jsonObjectSh;
		}
		// Framing links
		const f = document.createElement('div');
		f.className = 'framingLinks';
		f.style.cssText = 'display:inline-block;position:relative;top:-6px;';
		f.innerHTML = '<a href="https://www.historicpictoric.com/pages/framing-options" target="_blank" style="text-decoration:underline;color:blue;">About Framing</a>';
		const [f2, f3] = ['Type', 'Mat Style'].map(n => [...document.querySelectorAll('fieldset')].find(f => f.querySelector(`input[option_name="${n}"]`)));
		matchMedia("(max-width: 600px)").matches ? (f3?.after(f), f.style.marginTop = '15px') : f2?.appendChild(f);
		//Tooltip
		const tooltip = document.createElement("div");
		tooltip.className = "type_tooltip";
		document.body.appendChild(tooltip);
		let activeLabel = null;
		let canTap = true;
		let scrollTimeout;
		function showTooltipAtLabel(label, text) {
			const rect = label.getBoundingClientRect();
			const top = Math.max(0, rect.top - 10);
			const left = Math.min(window.innerWidth, rect.left + rect.width / 2);

			tooltip.innerText = text;
			tooltip.style.left = `${left}px`;
			tooltip.style.top = `${top}px`;
			tooltip.style.display = "block";
			tooltip.style.visibility = "visible";
			tooltip.style.opacity = "1";
		}
		function hideTooltip() {
			tooltip.style.visibility = "hidden";
			tooltip.style.opacity = "0";
			tooltip.style.display = "none";
			activeLabel = null;
		}
		function lockTapAfterScroll() {
			canTap = false;
			clearTimeout(scrollTimeout);
			scrollTimeout = setTimeout(() => {
				canTap = true;
			}, 100);
		}
		document.querySelectorAll("fieldset").forEach(fieldset => {
			fieldset.querySelectorAll("input[type='radio'], input[type='checkbox']").forEach(input => {
				const tooltipText = input.getAttribute("data-tooltip");
				if (!tooltipText) return;

				const label = fieldset.querySelector(`label[for="${input.id}"]`);
				if (!label) return;

				label.addEventListener("touchend", (e) => {
					if (!canTap) return;
					//   e.preventDefault();
					if (activeLabel === label) return;
					activeLabel = label;
					showTooltipAtLabel(label, tooltipText);
				});

				label.addEventListener("click", () => {
					if (activeLabel === label) return;
					activeLabel = label;

					showTooltipAtLabel(label, tooltipText);

				});

				label.addEventListener("mouseenter", () => {
					if (window.innerWidth <= 900) return;
					showTooltipAtLabel(label, tooltipText);
				});

				label.addEventListener("mouseleave", () => {
					if (window.innerWidth <= 900) return;
					hideTooltip();
				});
			});
		});
		window.addEventListener("scroll", () => {
			hideTooltip();
			lockTapAfterScroll();
		}, true);

		document.querySelectorAll("all-variant").forEach(container => {
			container.addEventListener("scroll", () => {
				hideTooltip();
				lockTapAfterScroll();
			}, true);
		});
		// Frame summary
		var createFrameSummary = document.createElement('div')
		createFrameSummary.innerHTML = `<div class="lb4b-summary" style="margin-bottom:2em;margin-top: 15px;"><ul style="margin-bottom:2em;margin-left:0; list-style:none;line-height:16px;" class="larf-frame-summary"></ul></div>`;
		var customContent = document.querySelector('.social-block-content');
		setTimeout(() => {
			document.querySelector('.product-form__buttons').after(createFrameSummary)
			if (window.matchMedia("(min-width: 320px) and (max-width: 750px)").matches) {
				document.querySelector('.lb4b-summary').style.marginBottom = '1em';
				document.querySelector('.lb4b-summary ul').style.marginBottom = '3px';
			}
			document.querySelector('.lb4b-summary').after(customContent)
			skuDisplay();
			addToCart();
		}, 1500);
		if (currentSize.height > currentSize.width) {
			currentSize.orientation = 'portrait'
			currentSize.lineSize = 40;
		} else {
			currentSize.orientation = 'landscape'
			currentSize.lineSize = 40;
		}

		//container size change based on orientation
		function containerSizeChange(selectedTypeValue) {
			const isMobile = window.matchMedia("(max-width: 600px)").matches;
			const isPortrait = currentSize.height > currentSize.width;
			if (selectedTypeValue == 'Framed') {
				if (isMobile) {
					containerSize = maxContainerSize = isPortrait ? 300 : 200;
				} else {
					containerSize = maxContainerSize = isPortrait ? 450 : 400;
				}
			} else if (selectedTypeValue == 'Infinity Frame') {
				if (isMobile) {
					containerSize = maxContainerSize = isPortrait ? 300 : 250;
				} else {
					containerSize = maxContainerSize = isPortrait ? 500 : 400;
				}
			} else {
				currentSize.firstMatSize = 0;
				if (isMobile) {
					containerSize = maxContainerSize = isPortrait ? 300 : 250;
				} else {
					containerSize = maxContainerSize = isPortrait ? 600 : 500;
				}
			}
			handleContainer();
		}
		// initial - print only SKU setup
		function skuDisplay() {
			const variantInput = document.querySelector('.product-variant-id');
			let skuValue;
			let skuFromBarcode;
			if (variantInput) {
				let valueFromSku = product_variants.find(item => item.id == variantInput.value)?.sku;
				let valueFromBarcode = product_variants.find(item => item.id == variantInput.value)?.barcode;
				if (valueFromBarcode && valueFromBarcode.split('_').length > 1) {
					skuFromBarcode = valueFromBarcode;
				}
				console.log('sku values', valueFromSku, valueFromBarcode, skuFromBarcode);
				skuValue = valueFromSku || skuFromBarcode
				console.log('sku value', skuValue);
			}
			const productInfo = document.querySelector('product-info');
			const productDescription = document.querySelector('.product__description.rte.quick-add-hidden');
			if (productInfo && skuValue) {
				const existingSku = productInfo.querySelector('.variant-sku');
				if (existingSku) {
					existingSku.textContent = skuValue;
				} else {
					const headingBlock = document.createElement('div');
					headingBlock.className = 'product-block';
					headingBlock.style.cssText = `max-width:1000px; margin:0 auto;`;
					const infoBlock = document.createElement('div');
					infoBlock.className = 'info-block';
					infoBlock.innerHTML = `<h4 class="more_info" style="margin-bottom: 0;"><span style="background: #8f191c; color: #fff; padding: 9px 15px; display: inline-block; font-size: 16px; font-weight: 400; margin-left: 3%;">More Information</span> </h4>`;
					const wrapperDiv = document.createElement('div');
					wrapperDiv.className = 'product-details-wrapper';
					wrapperDiv.style.cssText = `outline: medium none; padding: 20px 20px 50px; text-align: left; border: 1px solid #eff2f4; margin-left: 3%;`;
					const skuDiv = document.createElement('div');
					skuDiv.className = 'sku-box';
					const bold = document.createElement('b');
					bold.textContent = 'Sku:';
					const span = document.createElement('span');
					span.className = 'variant-sku';
					span.textContent = skuValue;
					skuDiv.appendChild(bold);
					skuDiv.append(' ');
					skuDiv.appendChild(span);
					wrapperDiv.appendChild(productDescription);
					wrapperDiv.appendChild(skuDiv);
					headingBlock.appendChild(infoBlock);
					headingBlock.appendChild(wrapperDiv);
					productInfo.appendChild(headingBlock);
				}
			} else {
				console.warn('<product-info> element not found or SKU is missing.');
			}
		}
		// addTocart fn for mobile view only
		function addToCart() {
			if (!window.matchMedia("(max-width: 600px)").matches) return;
			document.querySelector('.fixedLayer')?.remove();
			document.getElementById('newPreviewArea')?.remove();
			const size = document.querySelector('input[name="Size-1"]:checked')?.value || '';
			document.querySelector('.product-form__submit')?.style.setProperty('display', 'none');

			document.body.insertAdjacentHTML('beforeend', `<div class="fixedLayer" style="display:flex;align-items:center;justify-content:space-between;max-height:70px;height:70px;z-index:3;position:fixed;bottom:0;left:0;width:100%;background:#fff;padding:0 0 0 15px;border-top:1px solid #8f191c;"><div class="miniPicSide" style="flex:1;align-items:center;"></div><div class="pricingSide" style="flex:1.5;align-items:center;display:flex;flex-direction:column;"></div><div class="cartbtnSide" style="flex:3;align-items:center;"><button id="duplicateAddtoCart" style="background:#8f191c!important;color:#fff!important;padding:22px 0;width:100%;font-weight:700;">Add To Cart</button></div></div>`);

			const miniContainer = document.querySelector('.miniPicSide'),
				originalDiv = document.querySelector('.main-previewArea'),
				mainImageCanvas = document.querySelector('#frameViewCanvas');
			if (originalDiv && miniContainer && mainImageCanvas) {
				const clonedDiv = originalDiv.cloneNode(true),
					newMainFrameDiv = clonedDiv.querySelector('.mainFrameDiv'),
					newMainImageDiv = clonedDiv.querySelector('.mainimageDiv');

				clonedDiv.id = 'newPreviewArea';
				clonedDiv.classList.add('new' + clonedDiv.classList[1]);
				clonedDiv.classList.add('miniLivearfProduct');
				clonedDiv.style.width = '75%';
				clonedDiv.style.height = 'auto';
				clonedDiv.querySelector('#sideShow').id = 'new_sideshow_id';
				if (newMainFrameDiv) {
					let roomImageMatSize;
					let frameBorder;
					let typeInput = typeFS.querySelector('input[type="radio"]:checked');
					let selectedType = typeInput?.value || "";
					if (selectedType === "Canvas") {
						newMainFrameDiv.classList.remove('mirrorWrap');
						setTimeout(() => {
							document.querySelector('#new_sideshow_id').classList.remove('frameSide');
						}, 100);
						roomImageMatSize = 0;
					} else if (selectedType === "Infinity Frame") {
						newMainFrameDiv.classList.remove('hispicThreeDeffect');
						frameViewCanvas.classList.toggle('infinityFrameBorder', hispicThreeD);
						roomImageMatSize = 0;
						frameBorder = 0;
					} else if (selectedType === "Framed") {
						newMainFrameDiv.classList.remove('hispicThreeDeffect');
						frameViewCanvas.classList.toggle('infinityFrameBorder', hispicThreeD);
						newMainFrameDiv.classList.remove('mirrorWrap');
						sideWrapSh.classList.remove('frameSide');
						sideWrapSh.style.backgroundImage = "";
						roomImageMatSize = (currentSize.firstMatSize == 0) ? 0 : (currentSize.firstMatSize == 3) ? 5 : 3;
						frameBorder = 2;
					}
					const inlineStyles = {};
					for (let i = 0; i < newMainFrameDiv.style.length; i++) {
						const key = newMainFrameDiv.style[i];
						inlineStyles[key] = newMainFrameDiv.style.getPropertyValue(key);
					}
					inlineStyles.borderWidth = frameBorder + 'px';
					inlineStyles.padding = roomImageMatSize + 'px';
					inlineStyles.boxShadow = 'none';
					newMainFrameDiv.removeAttribute('style');
					newMainFrameDiv.classList.remove('mainFrameDiv');
					newMainFrameDiv.classList.add('new' + newMainFrameDiv.classList[0]);
					newMainFrameDiv._transferredStyles = inlineStyles;
				}
				if (newMainImageDiv) {
					newMainImageDiv.classList.add('new' + newMainImageDiv.classList[0]);
					newMainImageDiv.innerHTML = '';
					const img = new Image();
					Object.assign(img, {
						className: "newimage-magnify-lightbox",
						src: document.querySelector('#roomInnerDiv img').src
					});
					const baseStyles = { width: 'auto', height: 'auto', display: 'block', margin: '0 auto' };
					Object.assign(img.style, { ...baseStyles, ...(newMainFrameDiv._transferredStyles || {}) });
					// setTimeout(() =>{
					if (currentSize.orientation === 'portrait') {
						newMainImageDiv.style.height = '50px';
					}
					// },500)
					newMainImageDiv.appendChild(img);
				}
				miniContainer.appendChild(clonedDiv);
			}
			const originalPrice = document.querySelector('.livevue-display-price'),
				pricingSide = document.querySelector('.pricingSide');
			if (originalPrice && pricingSide) {
				console.log("here is the mobile pricing section", originalPrice)
				originalPrice.style.display = 'none';
				const priceClone = originalPrice.cloneNode(true);
				Object.assign(priceClone.style, { display: 'block', marginBottom: '2px', fontWeight: '500', fontSize: '16px' });
				const priceText = originalPrice.textContent.trim().split(' ')[0];
				priceClone.textContent = priceText;
				pricingSide.appendChild(priceClone);
				pricingSide.insertAdjacentHTML('beforeend', `<span id="sizeShowInBottom" style="font-size:12px;font-weight:700;display:block;">${size}</span>`);
			}
			document.getElementById('duplicateAddtoCart')?.addEventListener('click', () =>
				document.querySelector('button[name="add"]')?.click()
			);
			const drawer = document.getElementById('CartDrawer');
			if (drawer) {
				new MutationObserver(() => {
					const fixed = document.querySelector('.fixedLayer');
					if (fixed) fixed.style.zIndex = drawer.classList.contains('drawer--is-open') ? '-1' : '3';
				}).observe(drawer, { attributes: true, attributeFilter: ['class'] });
			}
			document.querySelectorAll('.product-form__input').forEach(el => {
				el.addEventListener('change', e => {
					console.log("target name:", e.target.getAttribute('option_name'));
					if (e.target.getAttribute('option_name') === 'Type') window.scrollTo(0, 0);
				});
			});
		}
		// zoom while hover 
		const img = document.getElementById('mediaGalleryImage');
		const mediaDiv = document.querySelector('#galleryView-preview .product__media.media--transparent');
		function updateZoomBackground() {
			const imgSrc = img.src.startsWith('//') ? 'https:' + img.src : img.src;
			mediaDiv.style.backgroundImage = `url('${imgSrc}')`;
		}
		updateZoomBackground();
		Object.assign(mediaDiv.style, { backgroundSize: '100%', backgroundPosition: '50% 50%', cursor: 'zoom-in', overflow: 'hidden', position: 'relative' });
		mediaDiv.classList.add('zoom');
		Object.assign(img.style, { opacity: '0', pointerEvents: 'none', width: '100%', height: 'auto' });
		mediaDiv.addEventListener('mousemove', e => {
			const rect = mediaDiv.getBoundingClientRect();
			const x = ((e.clientX - rect.left) / rect.width) * 100;
			const y = ((e.clientY - rect.top) / rect.height) * 100;
			mediaDiv.style.backgroundSize = '200%';
			mediaDiv.style.backgroundPosition = `${x}% ${y}%`;
		});
		mediaDiv.addEventListener('mouseleave', () => {
			mediaDiv.style.backgroundSize = '100%';
			mediaDiv.style.backgroundPosition = '50% 50%';
		});
		const observer = new MutationObserver(() => {
			updateZoomBackground();
		});
		observer.observe(img, { attributes: true, attributeFilter: ['src'] });
		document.querySelectorAll("div#previewIcons br").forEach(br => br.remove());
		document.querySelector('#frameView').lastChild.nodeValue = 'Preview';
		document.querySelector('#galleryView-preview .product__media.media--transparent').style.backgroundRepeat = 'no-repeat';
		if (document.querySelectorAll('#allImage ul li').length > 1) {
			console.log("inside product images >1")
			document.getElementById('galleryView').style.display = 'inline-block';
			document.getElementById('galleryView').click();
		} else {
			document.getElementById('galleryView').style.display = 'none';
		}
		// document.querySelectorAll('.room-thumb-icon').forEach(icon => {
		//   icon.addEventListener('click', () => {
		//     currentSize.lineSize = 40;
		//     console.log('lineSize set to:', currentSize.lineSize);
		//   });
		// });
		if (window.matchMedia("(max-width: 600px)").matches) {
			document.querySelector('#enlargeIcon').style.left = ' 86%';
			document.querySelector('.product__media-list li').style.setProperty('max-width', '100%', 'important');
			var mainRoomParentClass = document.getElementById('roomView-preview').querySelector('.product-media-container');
			mainRoomParentClass.style.height = '500px';
			mainRoomParentClass.style.marginBottom = '10%';
			var roomIconSetParentDiv = document.getElementsByClassName('roomsCollections')[0].parentElement.parentElement;
			roomIconSetParentDiv.style.bottom = '0px';
			setTimeout(() => {
				if (currentSize.height > currentSize.width) {
					currentSize.orientation = 'portrait'
				} else {
					currentSize.orientation = 'landscape'
				}
			}, 500)
		} else {
			var mainRoomParentClass = document.getElementById('roomView-preview').querySelector('.product-media-container');
			mainRoomParentClass.style.height = '500px';
			mainRoomParentClass.style.marginBottom = '20%';
			var roomIconSetParentDiv = document.getElementsByClassName('roomsCollections')[0].parentElement.parentElement;
			roomIconSetParentDiv.style.bottom = '-25%';
			document.querySelector('.social-sharing').style.marginLeft = '1.5em';
		}
		if (frameSelling == 'preview-only') {
			var lb4bNote = document.createElement('div');
			lb4bNote.className = 'preview-only';
			lb4bNote.innerHTML = `<span class="lb4-note" style="color:red"><font style="vertical-align: inherit;">
        <font style="vertical-align: inherit;">(Note: Frames are available for preview purposes only.</font></font><font style="vertical-align: inherit;"><font style="vertical-align: inherit;">)</font></font></span>`;
			var addToCartButton = document.querySelector('[name="add"]');
			addToCartButton.parentNode.insertBefore(lb4bNote, addToCartButton);
		}
		document.querySelectorAll('.swatch_options input[data-frame-url]').forEach(input => {
			var frameUrl = input.dataset.frameUrl;
			if (frameUrl.startsWith('//')) {
				input.dataset.frameUrl = 'https:' + frameUrl;
			}
		});
		const normalizeSize = (str) => {
			const nums = str?.match(/\d+/g);
			if (!nums || nums.length !== 2) return '';

			return nums.map(n => parseInt(n)).sort((a, b) => a - b).join(' x ');
		};
		// sku generator function
		function generateSku() {
			let skuSize = currentSize.selectedValue;
			let skuType = dataObject.find(item => item.type === "Type")?.value;
			let skuMat = dataObject.find(item => item.type === "Mat Size")?.value;
			let skuFrame = dataObject.find(item => item.type === "Frame Style")?.value;
			let prefixSku;
			const variantInput = document.querySelector('.product-variant-id');
			let skuFromBarcode;
			if (variantInput) {
				let valueFromSku = product_variants.find(item => item.id == variantInput.value)?.sku
				if (valueFromSku) {
					valueFromSku = valueFromSku.replace(/_P\d+$/, '');
				}
				let valueFromBarcode = product_variants.find(item => item.id == variantInput.value)?.barcode;
				if (valueFromBarcode && valueFromBarcode.split('_').length > 1) {
					skuFromBarcode = valueFromBarcode;
				}
				prefixSku = valueFromSku || skuFromBarcode
			}
			console.log("prefix sku:", prefixSku);
			let frameSku, matSku
			var skuData = ''
			if (skuType && skuType.toLowerCase() == 'framed') {
				skuData = 'F'
			} else if (skuType && skuType.toLowerCase() == 'print only') {
				skuData = 'P'
			} else if (skuType && skuType.toLowerCase() == 'infinity frame') {
				skuData = 'S'
			} else if (skuType && skuType.toLowerCase() == 'canvas') {
				skuData = 'C'
			} else if (skuType && skuType.toLowerCase() == 'peel and stick') {
				skuData = 'V'
			} else if (skuType && skuType.toLowerCase() == 'wood mount') {
				skuData = 'W'
			}
			skuData += skuSize.replace(/in|\s|x/gi, '');
			console.log("skudata :", skuData, skuType, skuFrame, skuMat);
			if (skuType && skuType.toLowerCase() == 'infinity frame') {
				skuData += 'AAA'
			} else if (skuType && skuType.toLowerCase() == 'framed') {
				if (skuMat && skuMat.replace(/\s+/g, "").toLowerCase() == '2.0in') {
					matSku = 'B'
				} else if (skuMat && skuMat.replace(/\s+/g, "").toLowerCase() == '3.0in') {
					matSku = 'C'
				} else if (skuMat && skuMat.toLowerCase() == 'no mat') {
					matSku = 'A'
				}
				if (skuFrame && skuFrame.toLowerCase() == 'black frame') {
					frameSku = 'AA'
				} else if (skuFrame && skuFrame.toLowerCase() == 'white frame') {
					frameSku = 'AB'
				} else if (skuFrame && skuFrame.toLowerCase() == 'brown frame') {
					frameSku = 'AC'
				}
				skuData += frameSku + matSku
			}
			var finalSku
			if (prefixSku) {
				finalSku = prefixSku + '_' + skuData
			} else {
				finalSku = skuData
			}
			console.log("finalsku:", finalSku);
			return finalSku
		}
		// all variant change function - for selected data only
		function getSelectedData() {
			dataObject = [];
			applyImageToCanvas(false);
			document.querySelectorAll('all-variant input:checked, all-variant select').forEach(el => {
				const source = el.tagName === 'SELECT' ? el.options[el.selectedIndex] : el;
				if (!source) return;
				// click frameView when option changes occurs in gallery view
				if (document.querySelector('#galleryView').classList.contains('selected')) {
					document.getElementById('frameView').click();
				}
				if (source.getAttribute('name') == 'Size-1') {
					mainFrameDivBorderWidth = mainFrameDiv.style.borderWidth;
					setTimeout(() => {
						console.log("inside size change");
						if (typeFS.querySelector('input[type="radio"]:checked').value === 'Peel and Stick') {
							applyImageToCanvas(true);
						} else {
							applyImageToCanvas(false);
						}
					}, 80);
					sizeElement_PS = {
						price: '',
						calculation_type: 'Fixed_Price',
						id: document.querySelector('.product-variant-id').value || '',
						type: source.getAttribute('option_name'),
						value: source.getAttribute('value'),
					}
				}
				if (source.getAttribute('option_name') == "Type") {
					console.log("selected type:", source.getAttribute('value'));
					if (source.getAttribute('value') == "Framed") {
						printOnlySelect = false;
						offsetwidth = document.getElementsByClassName('mainFrameDiv')[0].offsetWidth || containerSize;
					} else if (source.getAttribute('value') == "Print Only") {
						printOnlySelect = true;
					} else if (source.getAttribute('value') == "Peel and Stick") {
						printOnlySelect = false;
						applyImageToCanvas(true);
					} else if (source.getAttribute('value') === 'Infinity Frame') {
						printOnlySelect = false;
						setTimeout(() => {
							mainimageDiv.removeAttribute('style');
							mainFrameDiv.removeAttribute('style');
						}, 30);
					} else {
						console.log("selected type:", source.getAttribute('value'));
						printOnlySelect = false;
					}
          handleContainer()
				}
				if (source.getAttribute('data-predefined-price') && !printOnlySelect) {
					const inputSize = normalizeSize(currentSize.selectedValue);
					selectedOptions = JSON.parse(source.getAttribute('data-predefined-price')).filter(item => {
						return normalizeSize(item.title) === inputSize;
					});
					if (selectedOptions.length == 0) {
						selectedOptions[0] = {}
						selectedOptions[0].price = 0
						selectedOptions[0].id = ''
					}
					dataObject.push({
						price: selectedOptions[0].price,
						calculation_type: 'Fixed_Price',
						id: selectedOptions[0].id,
						type: source.getAttribute('option_name'),
						value: source.getAttribute('value'),
					});
				} else {
					dataObject.push({
						price: source.getAttribute('data-price') || '',
						calculation_type: source.hasAttribute('action')
							? source.getAttribute('price-type')
							: 'Fixed_Price',
						id: source.hasAttribute('action')
							? (source.getAttribute('data-variant-id') || '')
							: (document.querySelector('.product-variant-id')?.value || ''),
						type: source.getAttribute('option_name'),
						value: source.getAttribute('value'),
					});
				}
				console.log("selected value:", source.getAttribute('value'), printOnlySelect);
				if (source.getAttribute('option_name') == "Edge Color") {
					let edgeColorSelectedID = (source.getAttribute('id')) + '-description';
					woodMountColor = document.querySelector(`#${edgeColorSelectedID}`).innerText;
					woodMountColorName = source.value;
					console.log("edge color info:", woodMountColor, woodMountColorName);
					mainimageDiv.style.border = '5px outset ' + woodMountColor;
					roomInnerDiv.style.border = '2px outset ' + woodMountColor;
					draggableContainer.style.boxShadow = 'none';
				}
			});
			pricingCalculation(dataObject);
			applyVariantChange()
			hispicFrameSummary()
			setTimeout(() => {
				if (currentSize.height > currentSize.width) {
					currentSize.orientation = 'portrait'
					currentSize.lineSize = 40;
				} else {
					currentSize.orientation = 'landscape'
					currentSize.lineSize = 40;
				}
				console.log('Portrait image', currentSize.orientation);
				addToCart()
				skuDisplay()
			}, 100)
		}
		document.querySelectorAll('all-variant input, all-variant select')
			.forEach(el => el.addEventListener('change', getSelectedData)); // change function

		getSelectedData(); // onload

    function checkAndClickFramed() {
      document.querySelectorAll('.collectionID').forEach(element => {
        var collectionIdIs = element.getAttribute('id');
        if (photo_and_print_collection.includes(collectionIdIs)) {
          const framedInput = document.querySelector('input[option_name="Type"][value="Framed"]');
          if (framedInput) framedInput.click();
        }
      });
    }

    // 🟢 Run once on load
    // checkAndClickFramed();

		//Enlarge click
		var frameThickness;
		var elements = document.querySelectorAll('#enlargeIcon, #frameViewCanvas');
		elements.forEach(function (element) {
			element.addEventListener('click', function () {
				var frameCheckedElement = document.querySelector('input[action="frame"]:checked');
				frameThickness = frameCheckedElement ? parseFloat(frameCheckedElement.getAttribute('data-frame-width')) : 1;
				var selectedBGImage = frameCheckedElement ? frameCheckedElement.getAttribute('data-frame-url') : undefined;
				var src = mainImage.src;
				let matSizeInput = matSizeFS.querySelector('input[type="radio"]:checked');
				let matColorInput = matColorFS.querySelector('input[type="radio"]:checked');
				let selectedMatsize = matSizeInput?.value || "";
				let matImage = matColorInput ? matColorInput.getAttribute('data-frame-url') : undefined;
				console.log("selectedMatImage:", matImage);
				var dividedNumber = Number(currentSize.width) + (Number(frameThickness) * 2);
				console.log("zoom info:", dividedNumber, offsetwidth)
				var dividedWidth = offsetwidth / dividedNumber
				frameViewBorderWidth = dividedWidth * frameThickness;
				var frameViewMatWidth;
				if (selectedMatsize == '2.0 in') {
					frameViewMatWidth = (2 * Number(frameViewBorderWidth)).toFixed(2);
				} else if (selectedMatsize == '3.0 in') {
					frameViewMatWidth = (3 * Number(frameViewBorderWidth)).toFixed(2);
				} else {
					frameViewMatWidth = 0;
				}
				let typeInput = typeFS.querySelector('input[type="radio"]:checked');
				let selectedType = typeInput?.value || "";
				if (selectedType !== 'Framed') {
					frameViewBorderWidth = frameViewMatWidth = 0;
				}
				// needs to change based on type options if needed
				if (selectedType === 'Infinity Frame') {
					enlarge.innerHTML = '<img style="border-width:2px !important;border-style: solid !important; border-color:black !important; background-size:cover; background-repeat:no-repeat;background-position:center;" src="' + src + '">'
				} else if (selectedType === 'Wood Mount') {
					enlarge.innerHTML = '<img style="border: 3px outset ' + woodMountColor + '; padding: 0px !important; background-size:cover; background-repeat:no-repeat;background-position:center;" src="' + src + '">'
				} else {
					enlarge.innerHTML = '<img style="border-width:' + frameViewBorderWidth + 'px !important;border-style: solid !important; border-color:white !important; border-image: url(' + selectedBGImage + ') !important; border-image-slice: ' + 50 + ' !important; padding: ' + frameViewMatWidth + 'px !important; background-image:url(' + matImage + ') !important; background-size:cover; background-repeat:no-repeat;background-position:center;" src="' + src + '">'
				}
				document.getElementById('enlarge').style.display = 'block';
				document.getElementById('enlarge').style.cssText = "background: RGBA(109,109,109,.84); background-size: contain; width: 100%; height: 100%; position: fixed; z-index: 10000; top: 0; right: 0; left: 0; bottom: 0; cursor: zoom-out; display: flex; text-align: center; justify-content: center; padding: 15px;";
				if (window.matchMedia("(max-width: 600px)").matches) {
					enlarge.style.alignItems = 'center';
				} else {
					enlarge.style.alignItems = '';
				}
				document.getElementById('enlarge').addEventListener('click', function () {
					this.style.display = 'none';
				});
			});
		});
		// multiple click events on single variant listener to show complete mainImage in canvas
		document.getElementsByTagName('all-variant')[0].querySelectorAll('input, select, file').forEach((element) => {
			element.addEventListener('click', function (e) {
				if (typeFS.querySelector('input[type="radio"]:checked').value === 'Peel and Stick') {
					mainFrameDiv.removeAttribute('style');
					applyImageToCanvas(true);
				} else {
					applyImageToCanvas(false);
				}
			});
		});
		// preview icons change event
		document.querySelectorAll('#roomView, #frameView', '#galleryView').forEach(function (element) {
			element.addEventListener('click', function () {
				setTimeout(() => {
					if (typeFS.querySelector('input[type="radio"]:checked').value === 'Peel and Stick') {
						applyImageToCanvas(true);
					} else {
						applyImageToCanvas(false);
					}
					applyVariantChange()
				}, 120);
			});
		});
		// design type change function - UI setup
		function applyVariantChange() {
			console.log("inside apply variant change fn");
			let typeInput = typeFS.querySelector('input[type="radio"]:checked');
			let selectedType = typeInput?.value || "";
			if (selectedType === 'Framed') {
				mainFrameDiv.classList.remove('mirrorWrap');
				sideWrapSh.classList.remove('frameSide');
				sideWrapSh.style.backgroundImage = "";
				mainFrameDiv.classList.remove('hispicThreeDeffect');
				frameViewCanvas.classList.toggle('infinityFrameBorder', hispicThreeD);
				roomInnerDiv.style.boxShadow = 'none';
				if (!document.querySelector('input[action="frame"]:checked')) {
					document.querySelector('input[action="frame"][value="Black Frame"]').click();
				}
				if (!(currentSize.width === 24 && currentSize.height === 36) || !(currentSize.width === 36 && currentSize.height === 24)) {
					if (!document.querySelector('input[action="1st-mat-size"]:checked')) {
						document.querySelector('input[action="1st-mat-size"][value="2.0 in"]').click();
					}
					if (!document.querySelector('input[action="1st-mat-style"]:checked')) {
						document.querySelector('input[action="1st-mat-style"]').click();
					}
				}
				if (mainFrameDiv.children.length > 1) {
					mainFrameDiv.classList.remove('acrylicSandwichContainer')
					const acrylic = document.querySelector('.acrylicSandwich');
					if (acrylic) acrylic.remove();
					mainimageDiv.style.border = '0px';
				}
				containerSizeChange(selectedType)
			} else if (selectedType === "Wood Mount") {
				mainFrameDiv.classList.remove('mirrorWrap')
				sideWrapSh.classList.remove('frameSide');
				sideWrapSh.style.backgroundImage = "";
				mainFrameDiv.classList.remove('hispicThreeDeffect');
				frameViewCanvas.classList.toggle('infinityFrameBorder', hispicThreeD);
				mainFrameDiv.style.padding = '0px !important';
				mainFrameDiv.style.border = '0px !important';
				mainFrameDiv.classList.add('acrylicSandwichContainer')
				document.querySelector('#room-preview-image').style.border = 'none';
				draggableContainer.style.border = 'none';
				draggableContainer.style.padding = '0px';
				draggableContainer.style.boxShadow = 'none !important';
				if (!mainFrameDiv.querySelector('.acrylicSandwich')) {
					var acrylicSandWich = document.createElement('div');
					acrylicSandWich.innerHTML = '.';
					acrylicSandWich.className = 'acrylicSandwich';
					mainFrameDiv.appendChild(acrylicSandWich);
				}
				mainFrameDiv.style.backgroundColor = '#000';
				mainFrameDiv.style.border = 'none';
				if (!document.querySelector('input[option_name="Edge Color"]:checked')) {
					document.querySelector('input[option_name="Edge Color"]').click();
				}
				containerSizeChange(selectedType)
			} else {
				mainFrameDiv.style.padding = '0px !important';
				mainimageDiv.style.border = 'none';
				roomInnerDiv.style.border = 'none';
				mainFrameDiv.removeAttribute('style');
				document.querySelector('#room-preview-image').style.border = 'none';
				draggableContainer.style.border = 'none';
				draggableContainer.style.padding = '0px';
				draggableContainer.style.boxShadow = 'rgb(87, 87, 87) 1px 2px 4px -1px';
				if (mainFrameDiv.children.length > 1) {
					mainFrameDiv.classList.remove('acrylicSandwichContainer')
					const acrylic = document.querySelector('.acrylicSandwich');
					if (acrylic) acrylic.remove();
				}
				if (selectedType === "Canvas") {
					mainFrameDiv.classList.remove('hispicThreeDeffect');
					frameViewCanvas.classList.toggle('infinityFrameBorder', hispicThreeD);
					mainFrameDiv.classList.add('mirrorWrap');
					sideWrapSh.classList.add('frameSide');
					sideWrapSh.style.backgroundImage = "url('" + mainImage.src + "')";
				} else if (selectedType === "Peel and Stick") {
					mainFrameDiv.classList.remove('mirrorWrap')
					sideWrapSh.classList.remove('frameSide');
					sideWrapSh.style.backgroundImage = "";
					mainFrameDiv.classList.remove('hispicThreeDeffect');
					frameViewCanvas.classList.toggle('infinityFrameBorder', hispicThreeD);
				} else if (selectedType === "Infinity Frame") {
					document.querySelector('#draggableContainer').style.border = 'none';
					mainFrameDiv.classList.remove('mirrorWrap');
					sideWrapSh.classList.remove('frameSide');
					sideWrapSh.style.backgroundImage = "";
					mainFrameDiv.classList.add('hispicThreeDeffect');
					hispicThreeD = true;
					frameViewCanvas.classList.toggle('infinityFrameBorder', hispicThreeD);
					if (document.querySelector('#roomView').classList.contains('selected')) {
						document.querySelector('#room-preview-image').style.border = '1px solid #000';
					}
				} else if (selectedType === "Print Only") {
					mainFrameDiv.classList.remove('mirrorWrap')
					sideWrapSh.classList.remove('frameSide');
					sideWrapSh.style.backgroundImage = "";
					mainFrameDiv.classList.remove('hispicThreeDeffect');
					frameViewCanvas.classList.toggle('infinityFrameBorder', hispicThreeD);
				}
				containerSizeChange(selectedType)
			}
		}
		// peel and stick option
		function applyImageToCanvas(applyPeel = false) {
			console.log("Rendering image. Peel effect:", applyPeel);
			const canvas = document.getElementById('frameViewCanvas');
			const ctx = canvas.getContext("2d");
			const artwork = new Image();
			artwork.crossOrigin = "anonymous";
			artwork.src = mainImage.src;
			artwork.onload = () => {
				const containerWidth = canvas.parentElement.offsetWidth;
				const scaleFactor = containerWidth / artwork.width;
				const w = artwork.width * scaleFactor;
				const h = artwork.height * scaleFactor;
				canvas.width = w;
				canvas.height = h;
				ctx.clearRect(0, 0, w, h);
				ctx.drawImage(artwork, 0, 0, w, h);
				if (applyPeel) {
					const peel = new Image();
					peel.crossOrigin = "anonymous";
					peel.src = "https://cdn.shopify.com/s/files/1/0059/5404/3974/files/peel-sticker.png?v=1745567704";
					peel.onload = () => {
						var peelScale;
						if (window.matchMedia("(max-width: 600px)").matches) {
							peelScale = 0.1;
						} else {
							peelScale = 0.2;
						}
						const peelW = peel.width * peelScale;
						const peelH = peel.height * peelScale;
						ctx.drawImage(peel, 0, h - peelH, peelW, peelH);
					};
				}
			};
		}
		// Frame summary function
		function hispicFrameSummary() {
			var framed_image_width;
			var framed_image_height;
			let isFramed = false;
			let isMatSelected = false;
			let matSummary;
			let typeInput = typeFS.querySelector('input[type="radio"]:checked');
			let matSizeInput = matSizeFS.querySelector('input[type="radio"]:checked');
			let frameStyleInput = frameFS.querySelector('input[type="radio"]:checked');
			let matColorInput = matColorFS.querySelector('input[type="radio"]:checked');
			let selectedType = typeInput?.value || "";
			let selectedFrameStyle = frameStyleInput?.value || "";
			let selectedMatsize = matSizeInput?.value || "";
			let selectedMatcolor = matColorInput?.value || "";
			isFramed = selectedType === 'Framed';
			isMatSelected = selectedMatsize !== 'No Mat' && selectedMatsize !== '';
			console.log("selectedType: ", selectedType, " selectedFrameStyle : ", selectedFrameStyle, " selectedMatsize :", selectedMatsize, " selectedMatcolor: ", selectedMatcolor)
			if (isMatSelected && !isFramed) {
				framed_image_width = Number(currentSize.width) + 2 * Number(currentSize.firstMatSize);
				framed_image_height = Number(currentSize.height) + (2 * Number(currentSize.firstMatSize));
			} else if (isFramed && !isMatSelected) {
				framed_image_width = Number(currentSize.width) + 2 * Number(currentSize.frameThickness);
				framed_image_height = Number(currentSize.height) + (2 * Number(currentSize.frameThickness));
			} else if (isFramed && isMatSelected) {
				framed_image_width = Number(currentSize.width) + (2 * Number(currentSize.firstMatSize) + 2 * Number(currentSize.frameThickness))
				framed_image_height = Number(currentSize.height) + (2 * Number(currentSize.firstMatSize) + 2 * Number(currentSize.frameThickness));
			} else {
				framed_image_width = Number(currentSize.width);
				framed_image_height = Number(currentSize.height);
			}
			if (selectedMatcolor && isMatSelected) {
				matSummary = selectedMatsize + ' - ' + selectedMatcolor;
			} else {
				matSummary = selectedMatsize;
			}
			var framed_image_size = 'Finished Size : ' + framed_image_width + 'in x ' + framed_image_height + 'in';
			var framesummary = document.querySelector('.larf-frame-summary')
			var lb4bSummary = document.querySelector('.lb4b-summary');
			if (selectedType == 'Print Only') {
				if (lb4bSummary) lb4bSummary.style.display = 'none';
			} else {
				if (lb4bSummary) lb4bSummary.style.display = 'block';
				if (framesummary) {
					var summary = "<li style='text-decoration:underline; font-weight:600'>Product Summary</li>"
					if (selectedType == 'Framed') {
						summary = summary + '<li>Product Type : Giclée Print</li><li>Frame : ' + selectedFrameStyle + '</li><li>Frame Width : 1 in</li><li>Frame Height : 1 in</li><li>Mat : ' + matSummary + '</li><li>Glass : TruVue Acrylic Clear</li><li>Print Size : ' + currentSize.selectedValue + '</li><li>' + framed_image_size + '</li>'
						framesummary.innerHTML = summary
					} else if (selectedType == 'Infinity Frame') {
						summary = summary + '<li>Product Type : Fabric Print & Infinity Frame</li><li>Frame : Midnight Black</li><li>Frame Size: 5/8th in</li><li>Mat : No Mat</li><li>Print Size : ' + currentSize.selectedValue + '</li><li>' + framed_image_size + '</li>'
						framesummary.innerHTML = summary
					} else if (selectedType == 'Canvas') {
						summary = summary + '<li>Product Type :  Canvas Print, Gallery Wrap</li><li>Canvas Depth: 1 in</li><li>Mat : No Mat</li><li>Print Size : ' + currentSize.selectedValue + '</li><li>' + framed_image_size + '</li>'
						framesummary.innerHTML = summary
					} else if (selectedType == 'Peel and Stick') {
						summary = summary + '<li>Product Type : Peel-and-stick adhesive vinyl</li><li>Mat : No Mat</li><li>Print Size : ' + currentSize.selectedValue + '</li><li>' + framed_image_size + '</li>'
						framesummary.innerHTML = summary
					} else if (selectedType == 'Wood Mount') {
						summary = summary + '<li>Product Type :  Wood mounted print, UV coated</li><li>Edge Color : ' + woodMountColorName + '</li><li>Edge Depth: 3/8th in</li><li>Mat : No Mat</li><li>Print Size : ' + currentSize.selectedValue + '</li><li>' + framed_image_size + '</li>'
						framesummary.innerHTML = summary
					}
				}
			}
		}
		async function checkOrderJson(optionName) {
			if (orderJson) {
				for (const item of orderJson) {
					for (const variant of item.variants) {
						if (variant.variant_title === optionName) {
							if (variant.variant_price != updatedPriceFinal.toFixed(2)) {
								return {
									variantId: variant.variant_id,
									isVariant: true,
									priceNeedsUpdate: true,
									order_productId: item.order_product_id
								};
							}
							return {
								variantId: variant.variant_id,
								isVariant: true,
								priceNeedsUpdate: false
							};
						}
					}
				}
			}
			return {
				variantId: undefined,
				isVariant: false,
				priceNeedsUpdate: false
			};
		}
		async function shopifyFlow() {
			let properties = {}
			properties["Type"] = "Print Only"
			properties["SKU"] = generateSku();
			var cartData = {
				"id": document.querySelector('.product-variant-id').value,
				"properties": properties,
				"quantity": document.querySelector('.quantity__input').value
			};
			let cartResponse = await fetch('/cart/add.js', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(cartData)
			});
			if (!cartResponse.ok) {
				throw new Error('Failed to add item to cart');
			}
			await cartResponse.json();
			window.location.href = '/cart';
		}
		if (frameSelling == 'for-sale') {
			document.querySelector('[name=add]').addEventListener('click', async function (e) {
				e.preventDefault();
				if (printOnlySelect) {
					shopifyFlow()
				} else {
					getToken = await getShopToken("livearf_token");
					document.getElementById('frameView').click();
					document.getElementById('larfloader').style.display = 'flex';
					if (livevueImgUpload) {
						cropClick()
						var imgData = document.createElement('img')
						imgData.src = 'https://imageprocess.livearf.com/larfImageprocess?image_url=' + croppedData.originalImage + '&x=' + parseInt(croppedData[currentSize.ratio].x) + '&y=' + parseInt(croppedData[currentSize.ratio].y) + '&h=' + parseInt(croppedData[currentSize.ratio].height) + '&w=' + parseInt(croppedData[currentSize.ratio].width)
						var croppedKey = Object.keys(localStorage).find(key => key.includes('_croppedData'));
						orgImageUrl = localStorage.getItem(croppedKey);
						orgImageUrl = JSON.parse(orgImageUrl);
						orgImageUrl = orgImageUrl.value.originalImage;
						croppedImgUrl = orgImageUrl.slice(0, orgImageUrl.lastIndexOf('.')) + '_cropped' + '.jpeg';
					}
					let sizeObject = {
						type: "prod_var_id",
						calculation_type: 'Fixed_Price',
						id: '',
						type: 'Size',
						value: currentSize.selectedValue
					};
					let sizeIndex = dataObject.findIndex(item => item.type === 'Size');
					if (sizeIndex !== -1) {
						dataObject[sizeIndex] = sizeObject;
					} else {
						dataObject.unshift(sizeObject);
					}
					cloneElementForScreenShot();
				}
			});
		}
		//pricing function
		function pricingCalculation(dataObject) {
			const width = Number(currentSize.width);
			const height = Number(currentSize.height);
			const surfaceArea = (width * height);
			const circumference = 2 * (width + height);
			let finalPrice = 0;
			let infinityFrameSqInPrice;
			dataObject.forEach(item => {
				if (item.value === 'Infinity Frame') {
					let infinityPriceArray = document.querySelector(`input[option_name="Type"][value="Infinity Frame"]`)?.getAttribute('data-predefined-price');
					let priceArray = JSON.parse(infinityPriceArray);
					console.log("priceArray:", priceArray);
					let matchedItem = null;
					matchedItem = priceArray.find(priceObj => {
						const [itemSize, , surfaceList] = priceObj.title.split("/");
						return (
							itemSize === String(width) &&
							surfaceList.split("-").includes(String(surfaceArea))
						);
					});
					if (!matchedItem) {
						matchedItem = priceArray.find(priceObj => {
							const [itemSize, , surfaceList] = priceObj.title.split("/");
							return (
								itemSize === String(height) &&
								surfaceList.split("-").includes(String(surfaceArea))
							);
						});
					}
					console.log("matched price element:", matchedItem);
					if (matchedItem) {
						infinityFrameSqInPrice = parseFloat(matchedItem.price) * surfaceArea;
						item.price = infinityFrameSqInPrice;
						item.id = matchedItem.id;
						item.calculation_type = "Fixed_Price";
					}
				} else if (item.value === 'Peel and Stick') {
					let peelandStickPriceData = document.querySelector(`input[option_name="Type"][value="Peel and Stick"]`)?.getAttribute('data-price');
					let priceId = document.querySelector(`input[option_name="Type"][value="Peel and Stick"]`)?.getAttribute('data-variant-id');
					let pricePS = JSON.parse(peelandStickPriceData);
					let priceString = document.getElementById('larf-display-price').innerText;
					let pricePrintOly = parseFloat(priceString.match(/[\d.]+/)[0]);
					let peelStickPrice = pricePrintOly + (Number(pricePS / 100) * pricePrintOly);
					if (peelStickPrice) {
						item.price = peelStickPrice.toFixed(2);
						item.id = priceId;
						item.calculation_type = "Fixed_Price";
					}
				}
			});
			let selectedData = dataObject;
			selectedData.forEach(({ price, calculation_type }) => {
				if (!price) return;
				const itemPrice = parseFloat(price);
				switch (calculation_type) {
					case 'Perimeter':
						finalPrice += itemPrice * circumference;
						break;
					case 'Surface_Area':
						finalPrice += itemPrice * surfaceArea;
						break;
					case 'Fixed_Price':
						finalPrice += itemPrice;
						break;
				}
			});
			console.log("final updated price with addons : ", finalPrice);
			updatedPriceFinal = finalPrice;
			if (printOnlySelect) {
				const displayElement = document.getElementsByClassName('livevue-display-price')[0];
				displayElement.innerText = document.getElementById('larf-display-price').innerText;
				if (document.querySelector('[name=add]').disabled) {
					document.querySelector('[name=add]').disabled = false;
				}
			} else {
				const basePriceText = document.getElementById('larf-display-price').innerText;
				const displayElement = document.getElementsByClassName('livevue-display-price')[0];
				displayElement.innerText = moneyWithCurrency(basePriceText, finalPrice);
				if (updatedPriceFinal == 0 || updatedPriceFinal == 20 || updatedPriceFinal == 40) {
					if (!document.querySelector('[name=add]').disabled) {
						document.querySelector('[name=add]').disabled = true;
					}
				} else {
					if (document.querySelector('[name=add]').disabled) {
						document.querySelector('[name=add]').disabled = false;
					}
				}
			}
			toggleMessageBasedOnButton()
		}
		function toggleMessageBasedOnButton() {
			if (cart_button.disabled) {
				message.style.display = "block";
			} else {
				message.style.display = "none";
			}
		}
		//clone element function for screenShot.
		async function cloneElementForScreenShot() {
			var existingClonedDiv = document.getElementById('newPreviewArea');
			if (existingClonedDiv) existingClonedDiv.remove();
			var originalDiv = document.querySelector('.main-previewArea');
			var clonedDiv = originalDiv.cloneNode(true);
			clonedDiv.id = 'newPreviewArea';
			clonedDiv.classList.add('new' + originalDiv.classList[1]);
			var mainFrame = document.querySelector('.mainimageDiv');
			var newMainFrameDiv = clonedDiv.querySelector('.mainFrameDiv');
			var newMainImageDiv = clonedDiv.querySelector('.mainimageDiv');
			newMainFrameDiv.classList.add('new' + newMainFrameDiv.classList[0]);
			newMainFrameDiv.style.width = `${mainFrame.offsetWidth}px`;
			newMainImageDiv.classList.add('new' + newMainImageDiv.classList[0]);
			var imageElement = document.createElement('img');
			imageElement.className = "newimage-magnify-lightbox";
			imageElement.style.width = document.querySelector('#frameViewCanvas').offsetWidth + 'px';
			imageElement.style.height = document.querySelector('#frameViewCanvas').offsetHeight + 'px';
			livevueImgUpload ? imageElement.src = croppedImgUrl : imageElement.src = mainImage.src;
			clonedDiv.querySelector('#sideShow').id = 'new_sideshow_id_1';
			newMainImageDiv.appendChild(imageElement);
			originalDiv.parentNode.appendChild(clonedDiv);
			clonedDiv.style.display = 'none';
			var canvasElement = clonedDiv.querySelector('.newmainFrameDiv canvas');
			if (canvasElement) canvasElement.remove();
			orderProperties();
		}
		async function orderProperties() {
			if (document.querySelector('input[action="1st-mat-size"]:checked')?.getAttribute('value') == 'No Mat') {
				dataObject = dataObject.filter(item => item.type !== "Mat Style");
			}
			if (document.querySelector('input[option_name="Type"]:checked')?.getAttribute('value') == 'Peel and Stick') {
				var index = dataObject.findIndex(item => item.type === sizeElement_PS.type);
				dataObject[index] = sizeElement_PS;
			}
			var jsonObject = getOrderPropertiesSh()
			orderImage = mainImage.src;
			["livevue_orderImage", "livevue_frameStyles"].forEach((key) => localStorage.removeItem(key));
			localStorage.setItem("livevue_orderImage", orderImage);
			let optionName = Object.values(jsonObject).join("/");
			let checkOrder = await checkOrderJson(optionName);
			jsonObject["SKU"] = generateSku();
			let htmlImage = document.querySelector('.newmainFrameDiv')?.outerHTML;
			let frameStyles = document.querySelector(".mainFrameDiv")?.getAttribute("style") || "";
			localStorage.setItem("livevue_frameStyles", frameStyles);
			var variant_Data = {
				variant_data: dataObject,
				option_name: "Combination",
				option_value: optionName,
				width: currentSize.width,
				height: currentSize.height,
				shop_domain: Shopify.shop,
				app_name: 'larfsh',
				plt_prod_id: meta.product.id,
				plt_prod_name: document.querySelector('[property="og:title"]').content,
				plt_prod_handle: document.querySelector('[property="og:url"]').content.split('/').pop(),
				order_json: orderJson,
				html_element: htmlImage,
				product_sku: generateSku(),
				unit: 'mm'
			};
			console.log('variant_Data :', variant_Data)
			if (checkOrder.isVariant && !checkOrder.priceNeedsUpdate) {
				console.log('priceNO Needs to Update', variant_Data)
				result = { variantid: checkOrder.variantId }
			} else {
				console.log('priceNeedsUpdate', variant_Data)
				if (checkOrder.priceNeedsUpdate) {
					variant_Data.variant_update_data = {}
					variant_Data.variant_update_data.variant_id = checkOrder.variantId;
					variant_Data.variant_update_data.product_id = checkOrder.order_productId;
				}
				document.getElementById('larfloader').style.display = 'flex';
				let response = await fetch("https://lb4b-shopper-user.liveb4buy.com/lb4b/shopperuser/v1/ShopifyOrder/cartPagePricing", {
					method: 'POST',
					headers: getToken,
					body: JSON.stringify(variant_Data)
				});
				if (!response.ok) {
					throw new Error('Failed to fetch cart page pricing');
				}
				result = await response.json();
				if (!checkOrder.variantId) {
					localStorage.setItem('livevue_variantId', result.variantid)
				}
			}
			var cartData = {
				"id": result.variantid,
				"properties": jsonObject,
				"quantity": document.querySelector('.quantity__input').value
			};
			console.log("cartData", cartData)
			let cartResponse = await fetch('/cart/add.js', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(cartData)
			});
			if (!cartResponse.ok) {
				throw new Error('Failed to add item to cart');
			}
			await cartResponse.json();
			document.getElementById('larfloader').style.display = 'none';
			window.location.href = '/cart';
		}
		async function getShopHeader() {
			let resData = {}
			let postObj = {
				uniqueUrlId: shopUniqueId,
				appname: 'larfsh'
			}
			let postData = JSON.stringify(postObj)
			var shopHeader = await fetch("https://lb4bapi.liveb4buy.com/lb4b/api/v1/LARF_Keycloak/getShopKcToken", {
				method: 'post',
				body: postData,
				headers: {
					'Content-Type': 'application/json'
				}
			}).then((response) => {
				return response.json()
			}).then((res) => {
				resData.authorization = "Bearer " + res.access_token
				var t = JSON.parse(window.atob(res.access_token.split('.')[1]))["iss"].split("/")
				resData.realmname = t[t.length - 1]
				return resData
			});
			setWithExpiry("livearf_token", shopHeader, 1500000);
			return shopHeader;
		}
		async function getShopToken(value) {
			let livearf_token = getWithExpiry(value);
			if (livearf_token == null) {
				livearf_token = await getShopHeader();
			}
			return livearf_token;
		}
	}
}
else if (pathSh == 'cart') {
	console.log("inside cartpage with screenshot fn")
	loadjscssfile("https://shop.liveb4buy.com/lb4b-shop/dist/css/livevue-template.min.css", "css");
	let cartPage_data = document.getElementsByClassName('cart__item');
	for (let i = 1; i < cartPage_data.length; i++) {
		if (cartPage_data[i].children[1].children[0].children[0].href.includes('-livevue')) {
			cartPage_data[i].children[1].children[0].children[0].href = cartPage_data[i].children[1].children[0].children[0].href.split('-livevue')[0]
		}
	}
	let image = localStorage.getItem('livevue_orderImage');
	let style = localStorage.getItem('livevue_frameStyles');
	let container = document.getElementsByClassName('cart__item--image')[0];
	if(container && !container.children[0]) {
		if (document.getElementsByClassName('cart__item--image')[0].children[0] == undefined) {
		let html_content = `<div class="cart__item--image-container gradient global-media-settings"><img src="${image}" class="cart__item--image" alt="New Product Image" loading="lazy" width="150" height="226"></div>`;
		document.getElementsByClassName('cart__item--image')[0].insertAdjacentHTML('beforeend', html_content);
		let addedDiv = document.querySelector('.cart__item--image-container');
		if (addedDiv && style) {
			addedDiv.setAttribute('style', style);
			let computedStyle = window.getComputedStyle(addedDiv);
			addedDiv.style.borderWidth = `${parseFloat(computedStyle.borderWidth) / 4}px`;
			addedDiv.style.padding = `${parseFloat(computedStyle.padding) / 4}px`;
			addedDiv.style.borderColor = '';
		}
	}
	}
	
	let variantId = localStorage.getItem('livevue_variantId');
	if (variantId) {
		document.body.style.filter = 'blur(5px)';
		let intervalId = setInterval(async () => {
			try {
				const response = await fetch('/cart.js');
				if (!response.ok) throw new Error('Failed to fetch cart data');

				const cart = await response.json();
				const item = cart.items.find(i => i.variant_id == parseInt(variantId));

				if (item && parseFloat(item.price) > 0) {
					clearInterval(intervalId);
					localStorage.removeItem('livevue_variantId');
					document.body.style.filter = 'none';
					const priceEl = document.getElementsByClassName('cart__item')[1]?.children[1]?.children[2]?.children[0];
					if (priceEl && priceEl.innerText === '$0.00') {
    					location.reload();
					}
					// if (document.getElementsByClassName('cart__item')[1].children[1].children[2].children[0].innerText == '$0.00') {
					// 	location.reload();
					// }
				}
			} catch (error) {
				console.error('Error checking cart:', error);
			}
		}, 700);
	}
	// shipping profile creation
	var shopUniqueId = Shopify.shop.replace(".myshopify.com", "_myshopify");
	var cartPageLoader = document.createElement('div');
	cartPageLoader.id = 'larfloader';
	cartPageLoader.innerHTML = '<div class="loader-spinner"><p></p></div><div class="loader-text">  Please Wait...</div>';
	document.body.appendChild(cartPageLoader);
	// checkout button click event
	document.addEventListener('click', async function (e) {
		console.log("if checkout clicked to create shipping profile:", e.target.matches('[name="checkout"], [value="Checkout"], [href$="checkout"], [name="goto_pp"], [name="goto_gc"]'));
		if (
			e.target.matches('[name="checkout"], [value="Checkout"], [href$="checkout"], [name="goto_pp"], [name="goto_gc"]')
		) {
			document.getElementById('larfloader').style.display = 'flex';
			e.preventDefault();
			try {
				let cartResponse = await fetch('/cart.js');
				let cart = await cartResponse.json();
				let cartdata = {
					shopDomain: Shopify.shop,
					items: cart.items
				};
				console.log("cartdata is ", cartdata);
				let shopHeaders = await getShopHeader(shopUniqueId, 'larfsh');
				let response = await fetch("https://lb4bapi.liveb4buy.com/lb4b/api/v1/lb4_store_script/shippingPriceAndProfileCreation", {
					method: 'POST',
					headers: shopHeaders,
					body: JSON.stringify(cartdata)
				});
				console.log("shipping api response:", response);
				if (!response.ok) {
					throw new Error('Failed to fetch shipping profile data');
				}
				let result = await response.json();
				console.log(result);

				if (result.status == 'success') {
					window.location.href = "/checkout";
					document.getElementById('larfloader').style.display = 'none';
				} else {
					console.log("error in shipping profile creation");
					document.getElementById('larfloader').style.display = 'none';
				}
			} catch (error) {
				console.error("Error:", error);
			}
		}
	});
}
async function getShopHeader(uniqueurlId, appname) {
	let resData = {}
	let postObj = {
		uniqueUrlId: uniqueurlId,
		appname: appname
	}
	let postData = JSON.stringify(postObj)
	var shopHeader = await fetch("https://lb4bapi.liveb4buy.com/lb4b/api/v1/LARF_Keycloak/getShopKcToken", {
		method: 'post',
		body: postData,
		headers: {
			'Content-Type': 'application/json'
		}
	}).then((response) => {
		return response.json()
	}).then((res) => {
		resData.authorization = "Bearer " + res.access_token
		var t = JSON.parse(window.atob(res.access_token.split('.')[1]))["iss"].split("/")
		resData.realmname = t[t.length - 1]
		return resData
	})
	return shopHeader
}
function loadjscssfile(filename, filetype) {
	if (filetype == "js") { //if filename is a external JavaScript file
		var fileref = document.createElement('script')
		fileref.setAttribute("type", "text/javascript")
		fileref.setAttribute("type", "module")
		fileref.setAttribute("src", filename)
	}
	else if (filetype == "css") { //if filename is an external CSS file
		var fileref = document.createElement("link")
		fileref.setAttribute("rel", "stylesheet")
		fileref.setAttribute("type", "text/css")
		fileref.setAttribute("href", filename)
	}
	else if (filetype == "scss") { //if filename is an external SCSS file
		var fileref = document.createElement("link")
		fileref.setAttribute("rel", "stylesheet/scss")
		fileref.setAttribute("type", "text/css")
		fileref.setAttribute("href", filename)
	}
	if (typeof fileref != "undefined")
		document.getElementsByTagName("head")[0].appendChild(fileref)
}
}